/* eslint-disable no-unused-vars */
import React from "react";
import { Card } from "antd";
import "./index.scss";

const AgeingBuckets = () => {
  return (
    <Card className="ageing-buckets-card">
      <div className="ageing-buckets-header">
        <h3 className="card-title">Ageing Buckets</h3>
        <span className="coming-soon-badge">Coming Soon</span>
      </div>
      <div className="ageing-buckets-skeleton">
        {[80, 60, 40, 25].map((width, i) => (
          <div key={i} className="skeleton-row">
            <div className="skeleton-label" />
            <div className="skeleton-bar" style={{ width: `${width}%` }} />
            <div className="skeleton-count" />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default AgeingBuckets;
